<template>
  <div class="container">
    <div class="flex flex-wrap justify-left md:mt-10 md:mb-10">
          <div class="md:h-full md:w-1/2 flex justify-center">
            <div class="fadein ml-8">
                <img id="f2" src="../assets/images/portraits/portrait_5_1.jpeg" class="object-contain absolute w-72 md:w-1/3">
                <img id="f1" src="../assets/images/portraits/portrait_5_2.png" class="object-contain absolute w-72 md:w-1/3">
            </div>
          </div>
          <div class="md:h-full md:w-1/2 m-auto">
            <div>
              <span class="block mb-4 text-center text-4xl md:text-7xl font-bold tracking-tight text-gray-700 dark:text-white"><strong>{{$t('remove_background_image')}}</strong></span>
              <span v-html="$t('automatically_and_free')" class="block mb-2 text-center text-x md:text-2xl font-bold tracking-tight text-gray-700 dark:text-white"></span>
            </div>

            <div class="d-flex flex-column container1" dense align="center" justify="center" @click="$refs.file.click()">
              <div class="m-2">
                <button type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                  <svg class="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path></svg>
                  {{$t('upload_image')}}
                </button>
              </div>
              <div class="mt-2">
                <span v-html="$t('or_drag_and_drop_an_image')" class="block text-center text-sm md:text-lg font-bold tracking-tight text-gray-700 dark:text-white"></span>
                <span v-html="$t('or_copy_and_paste_an_image')" class="block text-center text-xs md:text-md font-bold tracking-tight text-gray-700 dark:text-white"></span>
              </div>
              <div class="pb-5 ma-0">
                <span style="font-size:9px; color:#999999" v-html="$t('by_uploading_an_image_you_here_by_agree_to_our')"></span>
              </div>
            </div>
            </div>
        <input type="file" ref="file" hidden @change="onImageSelected"/>
    </div>

    <v-divider></v-divider>

    <div class="flex flex-wrap justify-center mt-20 mb-20">
      <div>
        <span v-html="$t('instant_transparency')" class="block mb-4 text-center text-3xl md:text-4xl font-bold tracking-tight text-gray-700 dark:text-white"><strong>{{$t('remove_background_image')}}</strong></span>
      </div>
      <div class="flex flex-wrap justify-center mb-10">
        <div>
          <img width="360" src="../assets/images/eiffel_difference.png" alt="">
        </div>
        <div>
          <img width="360" src="../assets/images/rally_diff.png" alt="">
        </div>
        <div>
          <img width="360" src="../assets/images/heels_diff.png" alt="">
        </div>
      </div>
    </div>

      <v-divider></v-divider>

      <div class="flex flex-wrap justify-center mt-20 mb-20">
        <div class="md:h-full md:w-1/2 pl-2 pr-2">
          <div id="slider" class="beer-slider" data-beer-label="after">
            <img src="../assets/images/portraits/portrait_10_2.png" class="transparent" alt="">
            <div class="beer-reveal" data-beer-label="before">
              <img src="../assets/images/portraits/portrait_10_1.jpeg" alt="">
            </div>
          </div>
        </div>
        <div class="md:h-full md:w-1/2 pl-2 pr-2 m-auto">
          <span style="font-size:30px; font-weight:bold; line-height: normal;"><strong>Remove backgrounds 100% automatically in 5 seconds with one click</strong></span>
          <p style="font-size:20px; font-weight:500; line-height: normal;">Our online background remover instantly detects the subject from any photo and gives you a smooth & clear cutout.</p>
          <p style="font-size:20px; font-weight:500; line-height: normal;">Thanks to Simpleish's clever AI, you can slash editing time - and have more fun!</p>
          <p style="font-size:20px; font-weight:500; line-height: normal;">No matter if you want to make a background transparent (PNG) or add a color background to a photo - you can do all this and more with simpleish.io.</p>
        </div>
      </div>

      <v-divider></v-divider>
      
      <div class="flex flex-wrap justify-center mt-20 mb-20">
          <div class="md:h-full md:w-1/2 pl-2 pr-2 m-auto">
            <span style="font-size:30px; font-weight:bold; line-height: normal;"><strong>Easily integrate with your Software Workflow</strong></span>
            <p style="font-size:20px; font-weight:500; line-height: normal;">We've built an API that you can super easily integrate with only a few line of codes.</p>
            <div justify="center" align="center">
              <div>
                <v-card @click="getApiKey" class="pa-3" elevation="0" color="blue lighten-1">
                  <h5 style="color: #ffffff;"><strong><i class="fa fa-code"></i></strong></h5>
                  <h5 style="color: #ffffff;"><strong>Get your Api Key</strong></h5>
                </v-card>
              </div>
            </div>
          </div>
          <div class="md:h-full md:w-1/2 pl-2 pr-2">
            <img src="../assets/images/developer1.jpeg" alt="">
          </div>
        </div>

      <v-divider></v-divider>

      <div class="flex flex-col justify-center items-center md:mt-10">
        <div class="block p-10 text-start bg-white">
          <div class="md:h-full m-auto">
            <div>
              <span class="block mb-4 text-center text-xl md:text-3xl font-bold tracking-tight text-gray-700 dark:text-white"><strong>{{$t('remove_background_image')}}</strong></span>
              <span v-html="$t('automatically_and_free')" class="block mb-2 text-center text-x md:text-2xl font-bold tracking-tight text-gray-700 dark:text-white"></span>
            </div>

            <div dense align="center" justify="center" @click="$refs.file.click()">
              <div class="m-2">
                <button type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                  <svg class="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path></svg>
                  {{$t('upload_image')}}
                </button>
              </div>
              <div class="mt-2">
                <span v-html="$t('or_drag_and_drop_an_image')" class="block text-center text-sm md:text-lg font-bold tracking-tight text-gray-700 dark:text-white"></span>
                <span v-html="$t('or_copy_and_paste_an_image')" class="block text-center text-xs md:text-md font-bold tracking-tight text-gray-700 dark:text-white"></span>
              </div>
              <div class="pb-5 ma-0">
                <span style="font-size:9px; color:#999999" v-html="$t('by_uploading_an_image_you_here_by_agree_to_our')"></span>
              </div>
            </div>
            </div>
        <input type="file" ref="file" hidden @change="onImageSelected"/>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeContent',

  components: {
  },

  data () {
      return {
        dragover: false,
      }
    },

  computed: {
      loggedIn() {
        return this.$store.state.auth.status.loggedIn;
      }
    },
  
  mounted: function () {
    let externalScript = document.createElement('script')
    externalScript.setAttribute('src', 'https://unpkg.com/beerslider/dist/BeerSlider.js')
    document.head.appendChild(externalScript);

    externalScript.onload = () => {
      new window.BeerSlider( document.getElementById( "slider" ) )
    };
  },
  created() {
    
  },
  methods: {
    onImageSelected(event) {
      this.goToUpload(event, 'selection');
    },
    goToUpload(selectedFile, method) {
        this.$router.push({
          name: 'UploadPage',
          params: {
            selectedFile : selectedFile,
            method : method
            }
          });
      },
    getApiKey() {
        if(this.loggedIn)
        {
          this.$router.push('/client-details');
        }else{
          this.$router.push('/login');
        }
    },
    goToHomePage() {
      this.$router.push('/');
    },
    goToTermOfService() {
      this.$router.push('/term-of-service');
    },
    logout() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/');
    }
  }
}
</script>

<style> 
.removeImage {
  background-image: url('~@/assets/images/pineapple1.jpeg');
  position: relative;
  animation-name: example;
  animation-duration: 4s;
  animation-iteration-count: 3;
}

@keyframes example {
  0%   {background-image:url('~@/assets/images/pineapple1.jpeg'); left:0px; top:0px;}
  25%  {background-image:url('~@/assets/images/pineapple2.png'); left:200px; top:0px;}
}

.fadein{
  width: 600px;
  height: 200px;
}

.fadein img {
    -webkit-animation-name: fade;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 6s;
    animation-name: fade;
    animation-iteration-count: infinite;
    animation-duration: 6s;
}

@-webkit-keyframes fade {
    0% {opacity: 0;}
    53% {opacity: 1;}
    100% {opacity: 0;}
}
@keyframes fade {
    0% {opacity: 0;}
    53% {opacity: 1;}
    100% {opacity: 0;}
}

#f2 {
    background-color: lightblue;
}
#f1 {
    animation-delay: -3s;
}
</style>